import { createClient } from "@supabase/supabase-js";

/**
 * Browser Supabase client.
 *
 * Only the anon (public) key is exposed; every privileged operation happens in
 * an edge function. `detectSessionInUrl` lets supabase-js finish the OAuth
 * sign-in when the provider redirects the user back to the app.
 */
const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error(
    "Missing VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY. Copy app/.env.example to app/.env.local.",
  );
}

export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

/** Current access token used to authorize edge-function calls. */
export async function getAccessToken(): Promise<string | null> {
  const { data } = await supabase.auth.getSession();
  return data.session?.access_token ?? null;
}
